import { type TFunction } from "i18next";
import { ChevronRight, Pencil } from "lucide-react";

import { WFPButton } from "@/components/ui/button";

import { ACTION_BUTTON_CLASS } from "../constants";
import { type FarmerIdentificationType } from "../../../types";

interface ActionsCellProps {
  identificationType: FarmerIdentificationType;
  onOpenModal: (identificationType: FarmerIdentificationType, type: "edit" | "view") => void;
  t: TFunction;
}

const ActionsCell = ({ identificationType, onOpenModal, t }: ActionsCellProps) => (
  <div className="flex items-center justify-start gap-2">
    <WFPButton
      type="button"
      variant="outline"
      size="sm"
      className={ACTION_BUTTON_CLASS}
      onClick={() => onOpenModal(identificationType, "view")}
    >
      {t("common.view")}
      <ChevronRight className="size-4" aria-hidden="true" />
    </WFPButton>
    <WFPButton
      type="button"
      variant="secondary"
      size="sm"
      className={ACTION_BUTTON_CLASS}
      onClick={() => onOpenModal(identificationType, "edit")}
    >
      <Pencil className="size-4" aria-hidden="true" />
      {t("common.edit")}
    </WFPButton>
  </div>
);

export { ActionsCell };
